module.exports = __webpack_public_path__ + "img/image27.cfcccab6.jpeg";